import { p as promiseResolve, b as bootstrapLazy } from './index-6a8d4a1b.js';

/*
 Stencil Client Patch Esm v2.2.0 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["img-comparison-slider",[[1,"img-comparison-slider",null,[[0,"keydown","onKeyDown"],[0,"keyup","onKeyUp"],[1,"mousedown","onMouseDown"],[9,"mouseup","onMouseUp"],[1,"touchstart","onTouchStart"],[0,"touchmove","onTouchMove"],[1,"touchend","touchEnd"],[0,"blur","onBlur"],[0,"focus","onFocus"],[9,"resize","updateAfterWidth"]]]]]], options);
  });
};

export { defineCustomElements };
